import { BaseService, Service } from "/@/cool";

@Service("customizedOrderStatusForShop")
class CustomizedOrderStatusForShop extends BaseService {
	page(data: any) {
		return this.request({
			url: "/page",
			method: "POST",
			data
		});
	}

	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	batchUpdate(data: any) {
		return this.request({
			url: "/batchUpdate",
			method: "POST",
			data
		});
	}
}

export default CustomizedOrderStatusForShop;
